import type { TourModule } from '@modules/product-updates/tours/tourTypes';

export const PROFILE_PHOTO_ANCHOR = 'profile-photo';

// The photo of the user's own account page (`UserOverviewCard.tsx`). Played
// from "Show me" on `content/releases/polished-portrait-preset`.
export const profilePhotoTour: TourModule = {
  steps: t => [
    {
      anchor: PROFILE_PHOTO_ANCHOR,
      title: t('Polish your profile photo'),
      body: t(
        'Click your photo, then Enhance with AI. Under Quality, pick Polished portrait for a refined look that still looks like you.',
      ),
      placement: 'right-start',
    },
  ],
  resolvePath: async ({ userId }) => `/users/${userId}/overview`,
};
